/**
 * Load window globals
 */

import 'foundation-sites';
$(document).on('domReady', () => {
    $(document).foundation();
});
